export type Popup = {
  title: string;
  description: string;
  buttonText: string;
  urlTarget: string;
};

const skPopup: Popup = {
  title: 'Ukáž <em>mame</em>,<br> že na ňu myslíš',
  description: 'Zaplať cez BLIK a získaj 10 EUR<br> za darček plný lásky',
  buttonText: 'Ukáž viac',
  urlTarget: '/t/sperky',
};

export const promoDialogContent: { [lang: string]: Popup } = {
  sk: skPopup,
};
